const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  fetchList: ({ commit }) => {
    let data = [
      { id: 1, name: 'Course #1' },
      { id: 2, name: 'Course #2' },
      { id: 3, name: 'Course #3' }
    ];
    commit('SET_ITEM', data);
  }
};

export default { namespaced, state, getters, mutations, actions };
